import { z } from 'zod';

import {
    FieldDictionaryAmountIndicator,
    FieldDictionaryEditability,
    FieldDictionaryEntityName,
    ContactType,
    FieldDictionaryControlType,
    FieldDictionaryControlSubType,
} from '../../../../types/Enums';

export const fieldDictionaryFormSchema = z
    .object({
        // Basic
        Required: z.boolean().nullable(),
        Visible: z.boolean().nullable(),
        NeverVisible: z.boolean().nullable(),
        Editability: z.nativeEnum(FieldDictionaryEditability).nullable(),
        Label: z
            .string()
            .trim()
            .nullable()
            .transform((val) => val || null),
        FieldName: z.string().trim().min(1, 'Field Name is required'),

        // Advanced
        XPath: z
            .string()
            .trim()
            .nullable()
            .transform((val) => val || null),
        JSONPath: z
            .string()
            .trim()
            .nullable()
            .transform((val) => val || null),
        EntityName: z.nativeEnum(FieldDictionaryEntityName),
        ContactType: z.nativeEnum(ContactType).nullable(),
        ShowVisibilityToggleCheckbox: z.boolean().nullable(),
        ControlType: z.nativeEnum(FieldDictionaryControlType).nullable(),
        ControlSubType: z.nativeEnum(FieldDictionaryControlSubType).nullable(),
        ControlFormat: z.record(z.string().trim().min(1), z.string().trim().min(1)).nullable(),
        AdjustmentMethodId: z.number().nullable(),
        AdjustmentReasonId: z.number().nullable(),
        AmountIndicator: z.nativeEnum(FieldDictionaryAmountIndicator).nullable(),
        LinePriority: z.number().nullable(),
        DefaultControlWidth: z.number().nullable(),
        MinimumControlWidth: z.number().nullable(),
        DisplayOrder: z.number().nullable(),
        DisplayHints: z
            .string()
            .trim()
            .nullable()
            .transform((val) => val || null),
        StaticDefaultValue: z
            .string()
            .trim()
            .nullable()
            .transform((val) => val || null),
        LabelCssClass: z
            .string()
            .trim()
            .nullable()
            .transform((val) => val || null),
        ValueCssClass: z
            .string()
            .trim()
            .nullable()
            .transform((val) => val || null),
    })
    .passthrough();

export type FieldDictionaryFormData = z.infer<typeof fieldDictionaryFormSchema>;
